const assetContext = require.context('./assets', true, /\.(avif|gif|jpe?g|png|svg|webp)$/);

const assetMap = assetContext.keys().reduce((map, key) => {
  const fileName = key.replace(/^\.\//, '');
  const url = assetContext(key);

  map[`assets/${fileName}`] = url;
  map[`/assets/${fileName}`] = url;

  return map;
}, {});

export function asset(path) {
  return assetMap[path] || assetMap[path.replace(/^\//, '')] || path;
}

export default assetMap;
